<h1>{{ 'Turbo.NewCompanyDialog.Headline' | translate : 'New customer' : null : 'Headline for new customer'}}</h1>
@if(isLoading) {
<h2>{{ 'Turbo.NewCompanyDialog.lbSavingCustomer' | translate : 'Saving customer info' : null : 'Processing message for create customer.' }}...</h2>
}
<mat-form-field style="min-width: 500px; text-align: center; margin: 10px;">
  <mat-label>{{ 'Turbo.NewCompanyDialog.txtAnnataCustomerNumber' | translate : 'Annata customer number' : null : 'Label Annata customer number'}}</mat-label>
  <input #txtInput type="text" matInput [(ngModel)]="customerNumber">
</mat-form-field>
<div style="text-align: center; margin: 5px;">
  <button mat-flat-button color="primary" style="margin: 3px;" (click)="createCompanyWithNumber()">{{ 'Turbo.NewCompanyDialog.cmdCreateCustomer' | translate : 'Create' : null : 'Button Create'}}</button>
</div>
<h2 style="text-align: center;">{{ 'Turbo.NewCompanyDialog.lblOr' | translate : 'Or' : null : 'Label Or' }}</h2>
<div style="text-align: center; margin: 5px;">
  <button mat-flat-button color="primary" style="margin: 3px;" (click)="createCompanyManually()">{{ 'Turbo.NewCompanyDialog.cmdCreateManually' | translate : 'Create manually' : null : 'Button create manually'}}</button>
</div>
